import { http } from '../../config/axios'

export default function postPermission(permission: any): Promise<string> {
  return http
    .post('api/permissao', permission)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post permission', error)
      throw Error(error.response.data)
    })
}
